/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import PropTypes from "prop-types";

import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, ListSubheader, TextField, styled } from "@mui/material";
import { LoadingSpinner } from "../loading_spinner";

const StyledTextField = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  '& .MuiInputBase-input': {
    height: '0.2px !important',
    backgroundColor: 'white',
    borderRadius: '8px',
    paddingTop: '17px',
    fontSize: '14px',
  },
})

const DropdownSearchBar = ({ changeSearchText, placeholder, isFetching = false }) => {
  return (
    <ListSubheader
      sx={{
        backgroundColor: "white",
        maxWidth: '100%',
        paddingTop: "16px",
        position: "sticky",
        top: 0,
        zIndex: 1,
      }}
    >
      <StyledTextField
        autoFocus={false}
        fullWidth
        InputProps={{
          sx: { borderRadius: "20px" },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ justifyContent: "center", minWidth: "20px" }}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  height: "20px",
                  justifyContent: "center",
                  width: "20px",
                }}
              >
                <LoadingSpinner isLoading={isFetching} />
              </Box>
            </InputAdornment>
          )
        }}
        placeholder={placeholder}
        onChange={(e) => changeSearchText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== "Escape") {
            e.stopPropagation();
          }
        }}
      />
    </ListSubheader>
  );
};

export default DropdownSearchBar;

DropdownSearchBar.propTypes = {
  changeSearchText: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  placeholder: PropTypes.string,
};
